// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"55":"95c10856","59":"a580671c","218":"9f530e34","248":"30b1d924","318":"d05b3eb3","443":"1d6dcaf1","450":"0fa9f153","500":"45668ec0","501":"8eb84c5c","640":"3e79a1ee","702":"482f1afa","705":"faba0433","727":"f55bbb26","919":"d0bbbbaf"}[chunkId] + ".js";
};